import { tv } from 'tailwind-variants'

import { h3 } from '@ui-kit/core/typography'

export const quote = tv({
  slots: {
    wrapper: 'flex flex-1 flex-row border-l-2 border-solid border-l-playground5-light pl-4',
    text: h3({ type: 'primary' }),
  },
})
